/**
 * Real WeNext customer reviews, as published on wenext.ai.
 *
 * 🔴 THESE ARE NAMED, REAL CUSTOMERS. Every quote is reproduced exactly as they
 * gave it — do not reword, shorten, or "improve" one, and do not invent a new
 * entry. If a review changes on the marketing site, change it here too.
 *
 * Kept as data rather than markup so the copy can be edited without touching
 * layout, and so the carousel stays a presentation concern.
 */
export interface CustomerReview {
  /** Stable id, used as the React key and in the dot labels. */
  id: string;
  quote: string;
  name: string;
  /** Their business — shown under the name, as on the marketing site. */
  handle: string;
  initials: string;
  /**
   * Their photo, when we have one. Served from `public/assets/reviews`, so the
   * path is absolute and needs no import. Reviewers without one keep the
   * initials disc — the carousel falls back per reviewer, not all or nothing.
   */
  avatarUrl?: string;
}

export const TRIAL_REVIEWS: readonly CustomerReview[] = [
  {
    id: 'singh-haranam',
    quote:
      'WeNext completely changed how we manage customer conversations. Our team responds faster, stays organized, and never misses an opportunity. It’s made customer engagement much simpler and more effective',
    name: 'Singh Haranam',
    handle: 'ksastropaathadrusttaratnalayam',
    initials: 'SH',
    avatarUrl: '/assets/reviews/singh-haranam.jpg',
  },
  {
    id: 'rakesh-kumar',
    quote:
      'WeNext has made it much easier for us to manage customer enquiries. The AI chatbot helps us respond quickly and connect with customers more efficiently. It has been a valuable addition to the way we engage with our customers',
    name: 'Rakesh kumar',
    handle: '360digrii.official',
    initials: 'RK',
    avatarUrl: '/assets/reviews/rakesh-kumar.jpg',
  },
  {
    id: 'karthik-bala',
    quote:
      'WeNext is built on trust, reliability, and genuine customer relationships. They didn’t just provide us with a platform—they understood our business and became an extension of our team',
    name: 'Karthik Bala',
    handle: 'Rozana',
    initials: 'KB',
    avatarUrl: '/assets/reviews/karthik-bala.jpg',
  },
];

/**
 * How long each review holds before the carousel advances.
 *
 * Deliberately brisk: the point is to make it obvious there is more than one
 * review, not to let someone finish reading one in a single turn. Hover/focus
 * pauses the rotation and the dots jump back, which is how anyone who actually
 * wants to read a quote does so.
 */
export const REVIEW_ROTATE_MS = 2500;
